import script from "./KlarvertragIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./KlarvertragIndex.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/KlarvertragIndex.css?vue&type=style&index=0&id=433e85bc&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433e85bc"]])

export default __exports__